/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';

// models and services
import LiteralsService from '../../services/literals/LiteralsService';

// icons and styles
import { ReactComponent as BriefcaseIcon } from 'src/bw/goal/briefcase.svg';
import { HELP_DOMAIN } from 'src/utils/constants';
import GoalDrawer from './GoalDrawer';
import SalaryInput from '../salary-input/SalaryInput';

export default class NewJobDrawer extends Component<any, any> {
    public override render(): ReactComponentElement<any> {
        const drawerProps: any = this.props.drawerProps;

        return (
            <GoalDrawer
                drawerProps={drawerProps}
                handleBack={this.props.handleBack}
                handleUpdateCard={this.props.handleUpdateCard}
                handleChangeCard={this.props.handleChangeCard}
                handleDeleteCard={this.props.handleDeleteCard}
                showLoader={this.props.showLoader}
                hideLoader={this.props.hideLoader}
                icon={<BriefcaseIcon />}
                introContent={
                    <>
                        {LiteralsService.getLiteral('NewJobDrawer.intro')}
                        <br />
                        <br />
                        {LiteralsService.getLiteral('NewJobDrawer.intro2')}
                    </>
                }
                cashFlow={this.props.user.cashFlow}
                handleChangeCardDate={this.props.handleChangeCardDate.bind(this)}
                learnMoreContent={LiteralsService.getJsxLiteral('NewJobDrawer.introLink')}
                learnMoreUrl={HELP_DOMAIN ? `${HELP_DOMAIN}/articles/income` : null}
            >
                <SalaryInput
                    card={drawerProps.card}
                    handleChangeCardAttribute={this.props.handleChangeCardAttribute}
                    calloutText={LiteralsService.getLiteral('NewJobDrawer.takeHome')}
                />
            </GoalDrawer>
        );
    }
}
